// @flow

import * as React from 'react';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import type { Map } from 'ol/map';
import Overlay from 'ol/overlay';
import { translate } from "react-i18next";
import CloseIcon from '../../../../icons/closeWhite.svg';

type Props = {
    olMap: Map
}
type State = {
}

const Popup = styled.div`
        position: absolute;
        background-color: white;
        -webkit-filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2));
        filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2));
        border-radius: 10px;
        border: 4px solid #265a9c;
        bottom: 12px;
        left: -50px;
        min-width: 150px;
        z-index: 20;
        user-select: text;
        :before, :after {
            top: 100%;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
        }
        :after {
            border-top-color: white;
            border-width: 10px;
            left: 48px;
            margin-left: -10px;
        }
        :before {
            border-top-color: #cccccc;
            border-width: 11px;
            left: 48px;
            margin-left: -11px;
        }
`;

const Closer = styled.a`
        text-decoration: none;
        position: fixed;
        top: 0px;
        right: 0px;
        color: white;

        :hover {
            cursor: pointer;
        }
`;

const Content = styled.div`
        > h3 {
            font-size: 16px;
            background: #265a9c;
            margin: 0;
            padding: 5px;
            color: white;
        }
        p {
            margin: 0;
            padding: 10px 5px;
            display: flex;
            justify-content: space-between;
            color: #2d2d2d;
            font-size: 13px;
        }
`;

const AttributesWrapper = styled.div`
        max-height: 200px;
        overflow: auto;
`;

export class AttributeInspector extends React.Component<Props, State> {
    attributeInspectorContainer: any;
    closer: any;
    content: any;
    overlay: any;

    closeAttributeInspector = () => {
        this.overlay.setPosition(undefined);
        this.closer.blur();
        return false;
    }

    componentDidMount() {
        this.overlay = new Overlay({
            element: this.attributeInspectorContainer,
            autoPan: true,
            autoPanAnimation: {
                duration: 250
            }
        });

        this.closer.onclick = () => {
            this.closeAttributeInspector();
        }

        const { olMap } = this.props;
        olMap.addOverlay(this.overlay);
        const self = this;

        olMap.on('singleclick', function (evt) {
            const coordinate = evt.coordinate;
            const features = olMap.getFeaturesAtPixel(evt.pixel, { hitTolerance: 3});

            if (features && features[0].values_['layerName'] !== 'Photos') {
                const feature = features[0];
                const excludedAttributes = ['geometry', 'labelPoint', 'direction', 'color', 'visibility', 'layer', 'customId', 'id', 'layerName'];
                let htmlContent = Object.keys(feature.values_)
                    .filter(attribute => { return !excludedAttributes.includes(attribute) })
                    .map(attribute => {
                        return (
                            `<p>
                                <span>${attribute}:</span> 
                                <span>${feature.values_[attribute]}</span>
                            </p>`
                        )
                    }).join(' ');

                if (htmlContent) {
                    self.content.innerHTML = htmlContent;
                    self.overlay.setPosition(coordinate);
                }
                else self.closeAttributeInspector();
            }
            else self.closeAttributeInspector();
        });
    }

    render() {
        const {t} = this.props;
        return (
            <Popup innerRef={(node) => { this.attributeInspectorContainer = node }}>
                <Closer
                    innerRef={(node) => { this.closer = node }}>
                    <ReactSVG
                        path={CloseIcon}
                        style={{
                            fill: 'white',
                            width: '20px',
                            height: '20px',
                            alignItems: 'center',
                        }}
                    />
                </Closer>
                <Content>
                    <h3>{t('Attributes')}:</h3>
                    <AttributesWrapper innerRef={(node) => { this.content = node }}>
                    </AttributesWrapper>
                </Content>
            </Popup >
        );
    }
};

export default translate("translations")(AttributeInspector);
    


// WEBPACK FOOTER //
// ./src/containers/content/map/attributeInspector/AttributeInspector.jsx